import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import DataSourceResource from '../../../DataSource.resource';
import { convertToPostParams } from '../components/CreateWizard/DataSourceCreateFormSettings';
export const defaultReducerState = { res: getDefaultAsyncWrapperObj() };
// Action Types
const prefix = 'updateDataSource';
const CLEAR_DATA_SOURCE_STATE = `${prefix}/CLEAR_STATE`;
export const clearUpdateDataSourceState = () => ({
    type: CLEAR_DATA_SOURCE_STATE,
});
const updateDataSourceArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (inputPayload) => {
        let dataSourcePost = convertToPostParams(inputPayload);
        return DataSourceResource.putDataSource(dataSourcePost);
    },
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
};
export const updateDataSourceEpicReducer = loadResourcesUtils(updateDataSourceArgs);
// Reducer
export const updateDataSourceReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case CLEAR_DATA_SOURCE_STATE:
            return defaultReducerState;
        default:
            return updateDataSourceEpicReducer.reduxChange(state, action);
    }
};
export default updateDataSourceReducer;

//# sourceMappingURL=DataSourceUpdate.ducks.js.map
